var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.204 17.3766C10.5175 18.063 10.5175 19.176 11.204 19.8625C11.8904 20.549 13.0034 20.549 13.6899 19.8626L19.8627 13.69C20.1924 13.3604 20.3776 12.9133 20.3776 12.447C20.3776 11.9808 20.1924 11.5337 19.8627 11.204L13.6899 5.03151C13.0034 4.34506 11.8904 4.34509 11.204 5.03157C10.5175 5.71806 10.5175 6.83104 11.204 7.5175L16.1338 12.447L11.204 17.3766Z",
    fill: "#7B848A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03236 17.3766C4.34587 18.063 4.34584 19.176 5.0323 19.8625C5.71875 20.549 6.83173 20.549 7.51822 19.8626L13.6911 13.69C14.0207 13.3604 14.2059 12.9133 14.2059 12.447C14.2059 11.9808 14.0207 11.5337 13.6911 11.204L7.51822 5.03151C6.83173 4.34506 5.71875 4.34509 5.0323 5.03157C4.34584 5.71806 4.34587 6.83104 5.03236 7.5175L9.96214 12.447L5.03236 17.3766Z",
    fill: "#7B848A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.7797804d3bf2014d18577b381e8b4a10.svg";
export { ForwardRef as ReactComponent };